import React from 'react'
import { useTranslation } from 'react-i18next'

import { Heading } from '../../../App/Components'
import Spinner from '../../../App/Components/Spinner/Spinner'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import { useGetAbsenceRequestListQuery } from '../../AbsenceRequestNew/util/useAbsenceRequestQuery'

import { ListSection } from './ListSection/ListSection'
import { RequestListContainer } from './style'

export const RequestsList = () => {
  const { t } = useTranslation()

  const { data, status } = useGetAbsenceRequestListQuery()

  const { user, establishment } = useAppSelector(state => {
    return {
      user: state.users.currentUser,
      establishment: state.establishment.active,
    }
  })

  if (!establishment?.permissions.includes('absence_requests')) {
    return (
      <p>
        {t("You don't have the required subscription type to view this page")}
      </p>
    )
  }

  if (status === 'pending') {
    return <Spinner />
  }

  if (status === 'error') {
    return <p>something went wrong</p>
  }

  if (!user) {
    return <Spinner />
  }

  if (user.permissions && false === user.permissions.hrAbsencesManage) {
    return (
      <p>{t("You don't have the required permissions to view this page")}</p>
    )
  }

  const { APPROVED, PENDING, DECLINED } = data.reduce(
    (accumulator, absenceRequest) => {
      accumulator[absenceRequest.status].push(absenceRequest)
      return accumulator
    },
    { APPROVED: [], PENDING: [], DECLINED: [], CANCELED: [] },
  )

  return (
    <RequestListContainer>
      <Heading level={'pageTitle'}>{t('Absence requests')}</Heading>
      <ListSection statusArray={PENDING} statusTitle={'Pending'} />
      <ListSection statusArray={APPROVED} statusTitle={'Approved'} />
      <ListSection statusArray={DECLINED} statusTitle={'Declined'} />
    </RequestListContainer>
  )
}
